module.exports = __webpack_public_path__ + "static/media/step-1.644921b0.png";